import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

const SubtotalMenu = BootslideMenu.extend({
	menu: function () {
		let menuOptions = []
		_.each(this.options.calendars, calendar => {
			menuOptions.push(_.extend({
				target: e => {
					this.trigger('done', calendar.id)
				}
			}, calendar))
		})

		return {
			label: i18n.get('common.calendar.calendars'),
			target: menuOptions,
			width: 200,
			extraClass: 'has-bootslide-menu'
		}
	}
})

export default SubtotalMenu
SubtotalMenu.__filename__ = 'reports/common/subtotal-menu.js'
